import "./landing-page.scss";
import { useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  return (
    <header className="bg-blue-600 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-2xl font-bold">Buko Labs</h1>
        <nav>
          <a href="#featured-Services" className="mr-4 hover:underline">
            Featured Service
          </a>
          <a href="#featured-Clients" className="hover:underline">
            Featured Clients
          </a>
        </nav>
      </div>
    </header>
  );
};

const Hero: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-[url('https://images.pexels.com/photos/1109352/pexels-photo-1109352.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1')] bg-cover text-white h-screen flex flex-col justify-center items-center">
      <section className="bg-white opacity-95 p-20 flex flex-col justify-center items-center text-black rounded-lg">
        <h1 className="text-5xl font-bold mb-4 text-center">
          Welcome to the Epic Online Business Site
        </h1>
        <p className="text-xl mb-8 text-center">
          Service on exclusive items and win amazing deals.
        </p>
        <button
          className="bg-blue-500 text-white px-6 py-2 rounded-full font-semibold hover:bg-gray-200"
          onClick={() => navigate("login")}
        >
          Start
        </button>
      </section>
    </div>
  );
};

const FeaturedServices: React.FC = () => {
  const data = [
    {
      label: "Service 1",
      value:
        "https://images.pexels.com/photos/159862/art-school-of-athens-raphael-italian-painter-fresco-159862.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
      label: "Service 2",
      value:
        "https://images.pexels.com/photos/962312/pexels-photo-962312.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
      label: "Service 3",
      value:
        "https://images.pexels.com/photos/1209843/pexels-photo-1209843.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
  ];
  return (
    <div id="featured-Services" className="py-16 bg-gray-100">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-center mb-12">Featured Services</h2>
        <div className="flex flex-wrap">
          {data.map((Service, index) => (
            <div key={index} className="w-full md:w-1/3 px-4 py-2">
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <h3 className="text-2xl font-bold mb-2">{Service.label}</h3>
                <img src={Service.value} />
                <p className="text-gray-700">Description of {Service.label}.</p>
                <button className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700">
                  Place Service
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const FeaturedClients: React.FC = () => {
  const data = [
    {
      label: "Clients 1",
      value:
        "https://images.pexels.com/photos/164455/pexels-photo-164455.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
      label: "Clients 2",
      value:
        "https://images.pexels.com/photos/236915/pexels-photo-236915.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
      label: "Clients 3",
      value:
        "https://images.pexels.com/photos/248077/pexels-photo-248077.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
  ];

  return (
    <div id="featured-Clients" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-center mb-12">
          Featured Clients
        </h2>
        <div className="flex flex-wrap">
          {data.map((Clients, index) => (
            <div key={index} className="w-full md:w-1/3 px-4 py-2">
              <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
                <h3 className="text-2xl font-bold mb-2">{Clients.label}</h3>
                <img src={Clients.value} />
                <p className="text-gray-700">
                  Description of {Clients.label}.
                </p>
                <button className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700">
                  View Clients
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export function LandingPage() {
  return (
    <div id="LandingPage" className="landing-page">
      <Header />
      <Hero />
      <FeaturedServices />
      <FeaturedClients />
    </div>
  );
}

export default LandingPage;
